import { Radio, RadioProps, useTheme } from '@mui/material'
import './RadioElement.scss'

interface RadioElementProps extends RadioProps {

}

const RadioElement = (props: RadioElementProps) => {
    const theme = useTheme()
    const combineClassName = `${props?.className ?? ''} radio-custom-element `
    return (
        <Radio {...props}
            sx={{
                color: theme.palette.primary.main,
                '&.Mui-checked': {
                    color: theme.palette.primary.main,
                },
            }}
            className={combineClassName}
        />
    )
}

export default RadioElement
